var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-selector",style:(_vm.customStyle)},_vm._l((_vm.options),function(o){return _c('button',{key:o.value,attrs:{"is-selected":_vm.selectedTab === o.value},on:{"click":function($event){return _vm.emit(o)}}},[_vm._v("\n        "+_vm._s(o.text)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }